import GrowthAcquisitionEpicClient from 'bundles/epic/clients/GrowthAcquisition';
import { showPathwaysUserBased } from 'bundles/unified-common/utils/showPathways';

const isNonSurveyOnboardingEnabled = () => GrowthAcquisitionEpicClient.get('enableNonSurveyOnboarding');

const showNonSurveyNonPathwaysOnboarding = () => isNonSurveyOnboardingEnabled() && !showPathwaysUserBased();

export { isNonSurveyOnboardingEnabled, showNonSurveyNonPathwaysOnboarding };
